/*
 * Copyright (c) 2020. World Wide Generation Ltd
 */

import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { apiClient } from '../actions/api';
import { RootState } from '../reducers';
import { MetricGroup } from '../types/metricGroup';

export interface CustomMetricSurveyGroupsState {
  surveyId: string,
  data: MetricGroup[],
  errorMessage: string,
  errored: boolean,
  loaded: boolean
}

const getInitialState = () => {
  return { surveyId: '', data: [], errorMessage: '', errored: false, loaded: false } as CustomMetricSurveyGroupsState
}
const metricGroups = createSlice({
  name: 'customMetricSurveyGroups',
  initialState: getInitialState(),
  reducers: {

    load: (state, action) => {
      return { ...state, errored: false, errorMessage: '', surveyId: action.payload };
    },
    loaded: (state, action) => {
      return { ...state, loaded: true, data: action.payload, }
    },
    handleError: (state, action: PayloadAction<Error>) => {
      return { ...state, errored: true, errorMessage: action.payload.message };
    },
    unload: () => {
      return getInitialState();
    },

  }
})

const { load, loaded, handleError, unload } = metricGroups.actions

export const loadCustomMetricGroupsBySurveyId = (surveyId: string) => (dispatch: any, getState: () => RootState) => {

  if (!surveyId) {
    return;
  }

  const customMetricSurveyGroups = getState().customMetricSurveyGroups;
  if (customMetricSurveyGroups.surveyId === surveyId) {
    return;
  }

  dispatch(load(surveyId));

  apiClient.getCustomMetricSurveyGroups(surveyId)
    .then((data) => {
      const sortData = data.sort((a, b) => a.groupName.localeCompare(b.groupName))
      dispatch(loaded(sortData))
    })
    .catch((e) => handleError(e));
}

export const unloadCustomMetricGroupSurveyId = () => (dispatch: any) => {
  return dispatch(unload())
}

export default metricGroups.reducer

